export const PERMISSION_KEYS = {
  STATIC_PARENTS: {
    MANAGE_RELATIONSHIPS: "manage_relationships",
    MANAGE_USERS: "manage_users",
    MANAGE_WORKKARDS: "manage_workkards",
    MANAGE_ACTIVITY: "manage_activity",
    MANAGE_NOTES: "manage_notes",
    MANAGE_REPORTS: "manage_reports",
    MANAGE_TODOS: "manage_todos",
    MANAGE_PARTIES: "manage_parties",
  },

  DYNAMIC_PARENTS: {
    MERCURY: "can_access_mercury",
    INBOX: "can_access_inbox",
    FINANCIALS: "can_access_financials",
    AUTHORIZED_STATES: "authorized_states",
    LETTERS: "can_manage_letters",
  },

  RELATIONSHIPS: {
    SEND_B2B_REQUEST: "can_send_b2b_relationship_request",
    ACCEPT_REJECT_B2B_REQUEST: "can_accept_reject_b2b_relationship_request",
    MANAGE_CONTRACTS: "can_manage_contracts",
    DEASSOCIATE_B2B_RELATIONSHIP: "can_de_associate_b2b_relationship",
    ADD_REMOVE_EXCLUDE_LIST: "can_add_remove_organization_from_exclude_list",
    VIEW_B2B_WORKLOAD: "can_view_b2b_workload",
  },

  USERS: {
    REASSIGN_USER: "can_re_assign_a_user",
    EDIT_USER: "can_edit_user",
    BLOCK_USER: "can_block_a_user",
    ADD_USER: "can_add_user",
    RESET_PASSWORD: "can_reset_password",
    ADD_WATCHERS: "can_add_watcher",
    ACT_AS_HIDDEN_WATCHER: "can_act_as_hidden_watcher",
    VIEW_WORKLOAD: "can_view_workload",
  },

  WORKKARDS: {
    CREATE_WORKKARD: "can_create_workkard",
    CHANGE_WORKKARD_SPONSOR: "can_change_workkard_sponsor",
    ARCHIVE_WORKKARD: "can_archive_workkard",
    RECEIVE_UNASSIGNED_WORKKARDS: "can_receive_un_assigned_workkards",
    CLOSE_WORKKARD: "can_close_workkard",
    EDIT_WORKKARD: "can_edit_workkard",
    EDIT_CLOSED_WORKKARD: "can_edit_closed_workkard",
    REOPEN_WORKKARD: "can_reopen_workkard",
  },

  ACTIVITY: {
    CREATE_ACTIVITY: "can_create_activity",
    REOPEN_ACTIVITY: "can_reopen_activity",
    CLOSE_ACTIVITY: "can_close_activity",
    ACCEPT_REJECT_ACTIVITY: "can_accept_reject_activity",
    ARCHIVE_ACTIVITY: "can_archive_activity",
    ACCEPT_REJECT_BID: "can_accept_reject_bid",
    REASSIGN_ACTIVITY: "can_reassign_activity",
    RECEIVE_UNASSIGNED_ACTIVITIES: "can_receive_un_assigned_activities",
    CHANGE_ACTIVITY_OWNER: "can_change_activity",
    MARK_ACTIVITY_IN_PROGRESS: "can_mark_activity_as_in_progress",
    COMPLETE_ACTIVITY: "can_complete_activity",
    CLOSE_ACTIVITY_MIDTERM: "can_close_activity_during_mid_term",
    ASSIGN_B2B: "can_assign_b2b",
    EDIT_ACTIVITY: "can_edit_activity",
  },

  NOTES: {
    MANAGE_WORKKARD_NOTES: "can_manage_workkard_notes",
    MANAGE_WORKKARD_NOTES_PUBLIC: "can_add_public_notes_workkard",
    MANAGE_WORKKARD_NOTES_PRIVATE: "can_add_private_notes_workkard",
    MANAGE_WORKKARD_NOTES_PERSONAL: "can_add_personal_notes_workkard",
    MANAGE_ACTIVITY_NOTES: "can_manage_activity_notes",
    MANAGE_ACTIVITY_NOTES_PUBLIC: "can_add_public_notes_activity",
    MANAGE_ACTIVITY_NOTES_PRIVATE: "can_add_private_notes_activity",
    MANAGE_ACTIVITY_NOTES_PERSONAL: "can_add_personal_notes_activity",
    DELETE_UPDATE_NOTES_TIMEFRAME:
      "can_delete_update_notes_within_configured_time_frame",
    CLONE_NOTES: "can_clone_notes",
  },

  REPORTS: {
    ADD_MATRIX_REPORT: "can_add_matrix_report",
    CLOSE_ACTIVITY_IN_VIEWS: "can_close_act_in_views",
    COMPLETE_DIARY_IN_VIEWS: "can_complete_diary_in_views",
    APPLY_AGGREGATION_IN_VIEWS: "can_apply_aggregation_in_views",
  },

  TODOS: {
    CREATE_DIARY: "can_create_diary",
    EDIT_OWN_DIARY: "can_edit_own_diary",
    DELETE_TODO: "can_delete_todo",
    EDIT_TODO: "can_edit_todo",
    VIEW_DELETED_TODO: "can_view_deleted_todo",
    COMPLETE_REOPEN_DIARY: "can_completeorreopen_diary",
  },

  PARTIES: {
    CREATE_PARTY: "can_create_party",
    DELETE_PARTY: "can_delete_party",
  },

  SINGLE: {
    MANAGE_COMPANY_PROFILE: "can_manage_company_profile",
    MANAGE_SETTINGS: "can_manage_settings",
    INVITE_USER_TO_COMMUNITY: "invite_people_to_access_community",
    MANAGE_RULES: "can_manage_rules",
    MANAGE_ATLAS: "can_manage_atlas",
    CONNECT_MAILBOT: "can_connect_mailbot",
    ADD_CUSTOM_FIELDS: "can_add_custom_fields",
    MANAGE_COMMUNICATION: "can_manage_communication",
    ACCESS_BULK_INBOX: "can_access_bulk_inbox",
    MANAGE_WEBHOOKS: "can_manage_webhooks",
  },

  DYNAMIC: {
    AUTHORIZED_STATES: "AuthorizedStates",
    FINANCIAL_PERMISSIONS: "FinancialPermissions",
    INBOX_PERMISSIONS: "InboxPermissions",
    LETTER_ADMIN_PERMISSIONS: "LetterAdminPermissions",
    LETTER_WEB_PERMISSIONS: "LetterWebPermissions",
    MERCURY_PERMISSIONS: "MercuryPermissions",
    REVIEW_SYSTEM_PERMISSIONS: "ReviewSystemWebPermissions",
  },
};

export const USER_FORM_NAME = "addUserForm";

export const FORM_FIELDS = {
  FIRST_NAME: "first_name",
  MIDDLE_NAME: "middle_name",
  LAST_NAME: "last_name",
  EMAIL: "email",
  USERNAME: "username",
  PHONE: "phone",
  JOB_TITLE: "job_title",
  EE_CODE: "ee_code",

  USER_ID: "user_id",
  SUPERVISOR_ID: "supervisor_id",

  TEMP_USER: "temp_user",
  JOB_ROLE: "job_role",

  AUTHORIZED_STATES: "authorized_states",
  FINANCIAL_PERMISSIONS: "financial_permissions",
  INBOX_PERMISSIONS: "inbox_permissions",
  LETTER_ADMIN_PERMISSIONS: "letter_admin_permissions",
  LETTER_WEB_PERMISSIONS: "letter_web_permissions",
  MERCURY_PERMISSIONS: "mercury_permissions",
  REVIEW_SYSTEM_PERMISSIONS: "review_system_permissions",
};

export const ROLES = {
  UNSURE: "Unsure",
  SUPERVISOR: "Supervisor",
  ADMIN: "System Admin",
  EMPLOYEE: "Employee",
};

export const FORM_MODES = {
  ADD: "add",
  EDIT: "edit",
};

export const FEATURE_FLAGS = {
  RULE_ENGINE: "isRuleEngineEnable",
  APPLY_SUPERVISOR: "applySupervisor",
  TEMP_USER: "isTempUserEnable",
  ASSOCIATED_PARTY: "isAssociatedPartyEnable",
  MANAGE_TEMPLATE: "isEnableManageTemplate",
  ATLAS: "isAtlas",
  AGGREGATION_VIEWS: "isAggregationEnableInViews",
  LETTER_PERMISSIONS: "IsEnableLetterPermissionsInAdminSection",
  REVIEW_SYSTEM: "IsEnableReviewSystem",
  COMPLETE_DIARY: "isCompleteDiaryEnable",
  MAILBOT_PERMISSION: "isMailbotPermissionEnabled",
  CLOSE_WORKKARD: "isCloseWorkkardEnabled",
  MERCURY: "isMercuryEnabled",
  COMMUNICATION: "isCommunicationEnabled",
};

export const VALIDATION_TYPES = {
  REQUIRED: "required",
  EMAIL: "email",
  MIN_LENGTH: "minLength",
  MAX_LENGTH: "maxLength",
  ALPHANUMERIC: "alphanumeric",
  EE_CODE_FORMAT: "eeCodeFormat",
  LICENSE_FORMAT: "licenseFormat",
  FUTURE_DATE: "futureDate",
  AT_LEAST_ONE_PERMISSION: "atLeastOnePermission",
};

export const VALIDATION_PARAMS = {
  USERNAME_MIN_LENGTH: 6,
};

export const VALIDATION_FIELD_PREFIXES = {
  LICENSE_NUMBER: "license_number_",
  LICENSE_EXPIRATION: "license_expiration_",
};

export const PERMISSION_PREFIXES = {
  CHECKBOX: "chkbx_",
  CAN_LOWER: "can_",
  CAN_UPPER: "Can",
  STATE: "state_",
  TEMPLATE: "tmpl_",
};

export const TEMPLATE_MODULES = ["Workkard", "Activity"];

export const buildTemplateKey = (module, id) =>
  `${PERMISSION_PREFIXES.TEMPLATE}${String(module || "").toLowerCase()}_${id}`;

export const VALIDATION_MESSAGES = {
  REQUIRED: "This field is required",

  FIRST_NAME_REQUIRED: "First Name is required.",
  LAST_NAME_REQUIRED: "Last Name is required.",
  EMAIL_REQUIRED: "Email is required.",
  EMAIL_INVALID: "Invalid email address",
  USERNAME_REQUIRED: "Username is required.",
  USERNAME_MIN_LENGTH: "Use at least 6 characters.",
  USERNAME_FORMAT: "Invalid username. You can use lower-case letters (a-z), upper-case letters (A-Z) and digits (0-9).",
  JOB_ROLE_REQUIRED: "Job role is required.",
  SUPERVISOR_REQUIRED: "Supervisor is required.",
  TEMP_USER_REQUIRED: "Temporary User selection is required.",

  EE_CODE_FORMAT: "Only letters, numbers, and special characters including ~`@#$%*)(_{}:;\"/[]',&.- are allowed.",

  LICENSE_NUMBER_REQUIRED: "License Number is required.",
  LICENSE_FORMAT: "Invalid License Number. Only letters, numbers, spaces, parentheses ( ), and the ampersand (&) are allowed.",
  LICENSE_EXPIRATION_REQUIRED: "License Expiration Date is required.",
  LICENSE_EXPIRED: "Date or Date format is incorrect.",
  LICENSE_STATE_REQUIRED: "State is required.",
  LICENSE_DUPLICATION: "Do you wish to add the same license number for multiple states?",

  AT_LEAST_ONE_PERMISSION: "At least one permission must be selected",

  USERNAME_CHECKING: "Checking username availability...",
  USERNAME_AVAILABLE: "Username is available",
  USERNAME_UNAVAILABLE: "Username is not available",
};

export const UI_LABELS = {
  MANAGE_RELATIONSHIPS: "Manage Relationships",
  MANAGE_USERS: "Manage Users",
  MANAGE_WORKKARDS: "Manage Workkards",
  MANAGE_ACTIVITY: "Manage Activity",
  MANAGE_NOTES: "Manage Notes",
  MANAGE_REPORTS: "Manage Views",
  MANAGE_TODOS: "Manage Diary",
  MANAGE_PARTIES: "Manage Parties",

  SEND_B2B_REQUEST: "Can Send B2B Relationship Request",
  ACCEPT_REJECT_B2B_REQUEST: "Can Accept/Reject B2B Relationship Request",
  MANAGE_CONTRACTS: "Can Manage Contracts",
  DEASSOCIATE_B2B_RELATIONSHIP: "Can De-associate B2B Relationship",
  ADD_REMOVE_EXCLUDE_LIST: "Can Add/Remove organization from Exclude list",
  VIEW_B2B_WORKLOAD: "Can view Workload of B2B",

  REASSIGN_USER: "Can Re-assign a User",
  EDIT_USER: "Can Edit User",
  BLOCK_USER: "Can Block a User",
  ADD_USER: "Can Add User",
  RESET_PASSWORD: "Can Reset Password",
  ADD_WATCHERS: "Can Add Followers",
  ACT_AS_HIDDEN_WATCHER: "Can act as hidden Follower",
  VIEW_WORKLOAD: "Can view Workload of Users",

  CREATE_WORKKARD: "Can Create Workkard",
  CHANGE_WORKKARD_SPONSOR: "Can Change Workkard Owner",
  ARCHIVE_WORKKARD: "Can Archive Workkard",
  RECEIVE_UNASSIGNED_WORKKARDS: "Can receive Unassigned Workkard",
  CLOSE_WORKKARD: "Can Close Workkard",
  EDIT_WORKKARD: "Can Edit Workkard",
  EDIT_CLOSED_WORKKARD: "Can Edit Closed Workkard",
  REOPEN_WORKKARD: "Can Reopen Workkard",

  CREATE_ACTIVITY: "Can Create Activity",
  REOPEN_ACTIVITY: "Can Reopen Activity",
  CLOSE_ACTIVITY: "Can Close Activity",
  ACCEPT_REJECT_ACTIVITY: "Can Accept/Reject Activity",
  ARCHIVE_ACTIVITY: "Can Archive Activity",
  ACCEPT_REJECT_BID: "Can Accept/Reject Bid",
  REASSIGN_ACTIVITY: "Can Reassign Activity",
  RECEIVE_UNASSIGNED_ACTIVITIES: "Can receive Unassigned Activities",
  CHANGE_ACTIVITY_OWNER: "Can Change Activity Owner",
  MARK_ACTIVITY_IN_PROGRESS: "Can Mark Activity as In Progress",
  COMPLETE_ACTIVITY: "Can Complete Activity",
  CLOSE_ACTIVITY_MIDTERM: "Can Close Activity during Midterm",
  ASSIGN_B2B: "Can Assign To B2B",
  EDIT_ACTIVITY: "Can Edit Activity",

  MANAGE_WORKKARD_NOTES: "Can Manage Workkard Notes",
  MANAGE_ACTIVITY_NOTES: "Can Manage Activity Notes",
  MANAGE_WORKKARD_NOTES_PUBLIC: "Can Add Public Notes",
  MANAGE_WORKKARD_NOTES_PRIVATE: "Can Add Internal Notes",
  MANAGE_ACTIVITY_NOTES_PUBLIC: "Can Add Public Notes",
  MANAGE_ACTIVITY_NOTES_PRIVATE: "Can Add Internal Notes",
  DELETE_UPDATE_NOTES_TIMEFRAME:
    "Can Delete Notes within configured time frame",
  CLONE_NOTES: "Can Clone Notes",

  ADD_MATRIX_REPORT: "Can View Organization Workload",
  CLOSE_ACTIVITY_IN_VIEWS: "Can Close Activity in Views",
  COMPLETE_DIARY_IN_VIEWS: "Can Complete Diary in Views",
  APPLY_AGGREGATION_IN_VIEWS: "Can Apply Aggregation in Views",

  CREATE_DIARY: "Can Create Diary",
  EDIT_OWN_DIARY: "Can Edit Own Diary",
  DELETE_TODO: "Can Cancel other users Diaries",
  EDIT_TODO: "Can Edit other users Diaries",
  VIEW_DELETED_TODO: "Can View Deleted Diaries",
  COMPLETE_REOPEN_DIARY: "Can Complete/Reopen other users Diaries",

  CREATE_PARTY: "Can Create Parties",
  DELETE_PARTY: "Can Delete Parties",

  MANAGE_COMPANY_PROFILE: "Can Manage Company Profile",
  MANAGE_SETTINGS: "Can Manage Settings",
  INVITE_USER_TO_COMMUNITY:
    "Can Manage User Access to Your Organization Account",
  MANAGE_RULES: "Can Manage Rules",
  MANAGE_ATLAS: "Can send feed to Atlas",
  CONNECT_MAILBOT: "Can Connect to Mailbot",
  ADD_CUSTOM_FIELDS: "Can Manage CustomFields/Templates",
  MANAGE_COMMUNICATION: "Can Manage Communication",
  ACCESS_BULK_INBOX: "Can Access Bulk Inbox",
  MANAGE_WEBHOOKS: "Can Manage Webhooks",

  UNSURE: "Unsure",
  SUPERVISOR: "Supervisor",
  ADMIN: "System Admin",
  EMPLOYEE: "Employee",
};

export const getAllStaticPermissionKeys = () => {
  const allKeys = [];

  Object.keys(PERMISSION_KEYS).forEach((sectionKey) => {
    if (
      sectionKey !== "STATIC_PARENTS" &&
      sectionKey !== "DYNAMIC" &&
      sectionKey !== "SINGLE"
    ) {
      const section = PERMISSION_KEYS[sectionKey];
      Object.values(section).forEach((key) => allKeys.push(key));
    }
  });

  Object.values(PERMISSION_KEYS.SINGLE).forEach((key) => allKeys.push(key));

  Object.values(PERMISSION_KEYS.STATIC_PARENTS).forEach((key) =>
    allKeys.push(key),
  );

  return allKeys;
};

export const getPermissionKeysBySection = (section) => {
  return PERMISSION_KEYS[section] || {};
};

export const ADJUSTER_LICENSE_STATES = [
  { state_code: "AK", state_name: "Alaska" },
  { state_code: "AL", state_name: "Alabama" },
  { state_code: "AR", state_name: "Arkansas" },
  { state_code: "AZ", state_name: "Arizona" },
  { state_code: "CA", state_name: "California" },
  { state_code: "CO", state_name: "Colorado" },
  { state_code: "CT", state_name: "Connecticut" },
  { state_code: "CZ", state_name: "Canal Zone" },
  { state_code: "DC", state_name: "District of Columbia" },
  { state_code: "DE", state_name: "Delaware" },
  { state_code: "FL", state_name: "Florida" },
  { state_code: "GA", state_name: "Georgia" },
  { state_code: "GU", state_name: "Guam" },
  { state_code: "HI", state_name: "Hawaii" },
  { state_code: "IA", state_name: "Iowa" },
  { state_code: "ID", state_name: "Idaho" },
  { state_code: "IL", state_name: "Illinois" },
  { state_code: "IN", state_name: "Indiana" },
  { state_code: "KS", state_name: "Kansas" },
  { state_code: "KY", state_name: "Kentucky" },
  { state_code: "LA", state_name: "Louisiana" },
  { state_code: "MA", state_name: "Massachusetts" },
  { state_code: "MD", state_name: "Maryland" },
  { state_code: "ME", state_name: "Maine" },
  { state_code: "MI", state_name: "Michigan" },
  { state_code: "MN", state_name: "Minnesota" },
  { state_code: "MO", state_name: "Missouri" },
  { state_code: "MS", state_name: "Mississippi" },
  { state_code: "MT", state_name: "Montana" },
  { state_code: "NC", state_name: "North Carolina" },
  { state_code: "ND", state_name: "North Dakota" },
  { state_code: "NE", state_name: "Nebraska" },
  { state_code: "NH", state_name: "New Hampshire" },
  { state_code: "NJ", state_name: "New Jersey" },
  { state_code: "NM", state_name: "New Mexico" },
  { state_code: "NV", state_name: "Nevada" },
  { state_code: "NY", state_name: "New York" },
  { state_code: "OH", state_name: "Ohio" },
  { state_code: "OK", state_name: "Oklahoma" },
  { state_code: "OR", state_name: "Oregon" },
  { state_code: "PA", state_name: "Pennsylvania" },
  { state_code: "PR", state_name: "Puerto Rico" },
  { state_code: "RI", state_name: "Rhode Island" },
  { state_code: "SC", state_name: "South Carolina" },
  { state_code: "SD", state_name: "South Dakota" },
  { state_code: "TN", state_name: "Tennessee" },
  { state_code: "TX", state_name: "Texas" },
  { state_code: "UT", state_name: "Utah" },
  { state_code: "VA", state_name: "Virginia" },
  { state_code: "VI", state_name: "Virgin Islands" },
  { state_code: "VT", state_name: "Vermont" },
  { state_code: "WA", state_name: "Washington" },
  { state_code: "WI", state_name: "Wisconsin" },
  { state_code: "WV", state_name: "West Virginia" },
  { state_code: "WY", state_name: "Wyoming" },
];
